// @flow

import React, {type Node} from 'react';
import styled from 'styled-components';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { EWalletList } from './ewallet-list';
import { Empty, Separator } from '../../../../atoms';
import type { Country } from '@tectonics/prs/country';
import { EWalletUssdFields } from './ewallet-fields/ussd';
import { EwalletUpiCollectFields } from './ewallet-fields/upi-collect';
import { EwalletUpiIntentFields } from './ewallet-fields/upi-intent';
import { useUserInputValue } from '@tectonics/prs/user-input-values';

type props = {|
  country : Country,
|}

export function EWalletForm({ country }: props): Node {
  const allFeatures = useAllFeatures();
  const [selectedEWallet] = useUserInputValue('selectedEWallet');

  return (
    <Root>
      <IfFeature allFeatures={allFeatures} wanted="display_ewallet_accepts_brand">
        {renderTipMessage(country)}
        {renderEwalletList(country)}
        {renderEwalletFields(selectedEWallet)}
      </IfFeature>
    </Root>
  );
}

function getTipMessage(country: Country): string {
  switch (country) {
    case 'br':
      return 'Selecione sua carteira digital abaixo: ';
    case 'cl':
      return 'Seleccione su billetera electrónica abajo: ';
    case 'ke':
      return 'Please, select your mobile money operator: ';
    case 'ng':
      return 'Please, select your bank ';
    case 'in':
      return 'Select how are you going to pay with UPI';
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
      return 'Please, select your mobile money operator: ';
    default:
      throw new Error(`There is no tip message implementation for country "${country}".`);
  }
}

function renderEwalletFields(selectedEWallet: string): Node {
  switch (selectedEWallet) {
    case 'ussd':
      return <EWalletUssdFields />;
    case 'upi-collect':
      return <EwalletUpiCollectFields />;
    case 'upi-intent':
      return <EwalletUpiIntentFields />;
    default:
      return <Empty />;
  }
}

function renderEwalletList(country: string): Node {
  switch (country) {
    case 'ng':
      return <Empty />;
    default:
      return <EWalletList />;
  }
}

function renderTipMessage(country: Country): ?Node {
  return (
    <>
      <TipMessage> {getTipMessage(country)} </TipMessage>
      <Separator direction="v" size={3} />
    </>
  );
}

const Root = styled.div``;

const TipMessage = styled.p`
  color: ${props => props.theme.colors.gray(50)};
`;
